import React, { useState } from 'react'
import { useJoinNowContext } from '../../Context/joinNowContext';

function ContactMethod() {
    const { step, setStep ,selectContact, setSelectContactMethod } = useJoinNowContext()
    const Submit = () => {

        setStep(step + 1);

    };
    const handleChange = (value: string) => {
        setSelectContactMethod(value)
    }
    return (
        <div className='step1 w-[90%] xxs:p-4 p-6 sm:p-10 sm:w-[500px] mt-10 mb-10 md:w-[600px]  rounded-[4px] bg-[#303030] m-auto item-center justify-center   '>
            <h1 className="md:text-xl text-base text-white font-bold">We’re Here to Help</h1>
            <h1 className="md:text-sm text-base  mt-4 text-[#bbbbbb] ">Reach out to our dedicated support team for assistance and guidance.
                Select the method that works best for you to get in touch with us.</h1>
            <div className="flex space-x-2 xss:space-x-4 sm:space-x-10 mt-10 justify-center">
                {/* Radio Button 1 */}
                <div
                    className="px-2 py-2 sm:px-4 md:px-8 flex flex-row space-x-2 xss:space-x-4 xxs:space-x-1 item-center rounded-[4px] bg-[#3d3d3d] cursor-pointer"
                    onClick={() => handleChange('Send Email')}
                >
                    <label htmlFor="contact-radio1" className="relative inline-flex space-x-2 xss:space-x-4 xxs:space-x-1 items-center cursor-pointer">
                        <input
                            type="radio"
                            id="contact-radio1"
                            name="contact-method"
                            value="Send Email"
                            checked={selectContact === 'Send Email'}
                            onChange={() => handleChange('Send Email')}
                            className="hidden peer"
                        />
                        <span className="w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 peer-checked:border-red peer-checked:bg-red">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className={`w-3 h-3 text-white ${selectContact === "Send Email" ? "block" : "hidden"} transition-opacity duration-200`}
                                viewBox="0 0 20 20"
                                style={{ fill: '#fff' }}
                            >
                                <g data-name="Group 24954">
                                    <path
                                        data-name="Path 68503"
                                        d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                                        transform="translate(-4.373 -3.52)"
                                    />
                                </g>
                            </svg>
                        </span>
                        <h1 className="text-white xxs:text-xs text-sm sm:text-base ">Send Email</h1>
                    </label>
                </div>

                {/* Radio Button 2 */}
                <div
                    className="px-2 py-2 sm:px-4 md:px-8 flex flex-row space-x-2 xss:space-x-4 xxs:space-x-1 rounded-[4px] bg-[#3d3d3d] cursor-pointer"
                    onClick={() => handleChange('Mobile Number')}
                >
                    <label htmlFor="contact-radio2" className="relative space-x-2 xss:space-x-4 xxs:space-x-1 inline-flex items-center cursor-pointer">
                        <input
                            type="radio"
                            id="contact-radio2"
                            name="contact-method"
                            value="Mobile Number"
                            checked={selectContact === 'Mobile Number'}
                            onChange={() => handleChange('Mobile Number')}
                            className="hidden peer"
                        />
                        <span className="w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 peer-checked:border-red peer-checked:bg-red">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className={`w-3 h-3 text-white ${selectContact === "Mobile Number" ? "block" : "hidden"} transition-opacity duration-200`}
                                viewBox="0 0 20 20"
                                style={{ fill: '#fff' }}
                            >
                                <g data-name="Group 24954">
                                    <path
                                        data-name="Path 68503"
                                        d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                                        transform="translate(-4.373 -3.52)"
                                    />
                                </g>
                            </svg>
                        </span>
                        <h1 className="text-white xxs:text-xs text-sm sm:text-base md:text-base">Mobile Number</h1>
                    </label>
                </div>
            </div>

            <div className='flex w-full  h-auto   justify-end   '>
                <button className={`${(selectContact === "") ? "bg-inherite border border-[#4e4e4e]" : "bg-red"}  py-2 px-6 xxs:text-sm   w-max rounded-[5px] text-white font-bold text-base mt-10`}
                    disabled={(selectContact === '')}
                    onClick={Submit}
                >Next</button>
            </div>
        </div>
    )
}

export default ContactMethod
